export enum OrderItemStatus {
  OPEN = "open",
  APPROVED = "approved",
  DISAPPROVED = "disapproved",
  REJECTED = "rejected",
  DONE = "done",
  FAILED = "failed",
  FAILED_CANCEL = "failed_cancel",
  CANCELED = "canceled",
  EXPIRED_TIME = "expired_time",
  QUOTING = "quoting",
  QUOTED = "quoted",
  CANCELING = "canceling",
  WAITING_PAYMENT = "waiting_payment",
  WAITING_FINANCIAL_APPROVAL = "waiting_financial_approval",
  APPROVING = "approving",
  FINISHED = "finished",
  PARTIALLY_APPROVED = "partially_approved",
}
